<template>
  <div>
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12" class="px-2">
          <filter-header
            :activeAddButton="getPermissionModule('Article').adjust"
            :status-option="statusOption"
            :on-search-article="onSearchArticle"
            :on-select-filter="onSelectFilter"
            @onOpenExportModal="onOpenExportModal"
          />
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="articleTable.payload"
                responsive
                bordered
                borderless
                v-sortable-row="sortableRowOptions"
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table"
                :class="tableModeReorder ? 'table-reorder' : null"
                :key="tableModeReorder + keyChange"
                @sort-changed="sortingChanged"
              >
                <template #cell(article_cover)="data">
                  <div v-if="data.item.article_cover">
                    <img
                      :src="data.item.article_cover"
                      class="article-image-column"
                    />
                  </div>
                  <div v-else>-</div>
                </template>
                <template #cell(valid_from)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.valid_from)
                  }}</span>
                </template>
                <template #cell(valid_through)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.valid_through)
                  }}</span>
                </template>
                <template #cell(criteria_type_desc)="data">
                  <span>
                    {{ data.value || "None" }}
                  </span>
                </template>
                <template #cell(status)="data">
                  <b-form-checkbox
                    v-if="getPermissionModule('Article').adjust"
                    field-value="true"
                    class="custom-control-success custom-toggle"
                    name="check-button"
                    switch
                    :checked="data.item.status == 1 ? true : false"
                    @change="onToggleStatus($event, data.item)"
                  >
                    <span class="switch-icon-left toggle-text">{{
                      "Active"
                    }}</span>
                    <span class="switch-icon-right toggle-text">{{
                      "Inactive"
                    }}</span>
                  </b-form-checkbox>
                  <div v-else class="d-flex">
                    <span :style="data.item.status?'background-color:lightgreen;color:green;':'background-color:pink;color: red;'" style="padding: 5px 15px;border-radius: 18px;font-weight: bold;">{{ data.item.status?'Active':'Inactive' }}</span>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <action-group
                    v-if="getPermissionModule('Article').adjust"
                    :resolve-action="resolveArticleAction"
                    :set-action-list="articleActionList"
                    :item-data="data"
                  />
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            reordering
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
            @reorder="onClickReorder"
          />
        </b-col>
      </b-row>
    </b-card>
    <reorder-modal
      v-if="modalType.reorder"
      :current-index="currentIndex"
      :reorder-action="reorderArticle"
      @onCloseModal="closeModal"
    />
    <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.module"
      :moduleKey="defaultReport.article"
    />
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import AddButton from "@/views/components/button/AddButton.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import ReorderModal from "@core/components/reorder-modal/ReorderModal.vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import Sortable from "sortablejs";
import FilterHeader from "./components/FilterHeader.vue";
import useArticle from "./hooks/useArticle";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";
import {
  defaultReport,
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";
const createSortable = (el, options, vnode) =>
  Sortable.create(el, {
    ...options,
  });

const sortableRow = {
  name: "sortableRow",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
};

export default {
  directives: {
    sortableRow,
  },
  components: {
    BCard,
    BTable,
    BCol,
    BFormCheckbox,
    BSpinner,
    FilterHeader,
    AddButton,
    ActionGroup,
    PaginationWithReorder,
    ReorderModal,
    CardNoItem,
    BRow,
    HistoryReportModal,
  },
  setup() {
    const {
      statusOption,
      fields,
      loading,
      articleTable,
      articleActionList,
      keyChange,
      sortableRowOptions,
      onClickReorder,
      currentIndex,
      resolveArticleAction,
      reorderArticle,
      closeModal,
      tableModeReorder,
      resolveDateWithSeperator,
      pagination,
      ordering,
      onSelectFilter,
      onPageChange,
      onSearchArticle,
      sortingChanged,
      onFilterEntity,
      onToggleStatus,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      modalType,
      getPermissionModule
    } = useArticle();
    return {
      statusOption,
      fields,
      loading,
      articleTable,
      articleActionList,
      keyChange,
      sortableRowOptions,
      onClickReorder,
      currentIndex,
      resolveArticleAction,
      reorderArticle,
      closeModal,
      tableModeReorder,
      resolveDateWithSeperator,
      pagination,
      ordering,
      onSelectFilter,
      onPageChange,
      onSearchArticle,
      sortingChanged,
      onFilterEntity,
      onToggleStatus,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      defaultReport,
      defaultReportFilterType,
      defaultReportCategory,
      modalType,
      getPermissionModule
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/pages/article/article-table-list.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>
